export default __webpack_public_path__ + "static/media/emoties_controleren.14d6c4da.png";